<template>
  <el-dialog
    :title="title"
    :visible="visible"
    width="400px"
    class="template-selcte-dialog"
    @close="handleClose"
  >
    <div style="height:100px;overflow-y:scroll">
      <el-radio-group v-model="value">
        <el-radio
          v-for="option in options"
          :key="option.key"
          :label="option.key"
        >{{ option.name }}</el-radio>
      </el-radio-group>
    </div>
    <el-row
      slot="footer"
      style="margin-top:15px;"
    >
      <el-col
        :span="18"
        :offset="3"
        style="text-align:center"
      >
        <span>
          <el-button
            type="primary"
            @click="handleSubmit"
          >{{ $t('Message.Confirm2') }}</el-button>
          <el-button @click="handleClose">{{ $t('Message.Cancel2') }}</el-button>
        </span>
      </el-col>
    </el-row>
  </el-dialog>
</template>
<script>
import lang from '@/lang'
export default {
  name: 'TemplateSelectDialog',
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    title: {
      type: String,
      default: () => lang.t('Message.SelectTemplate')
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      value: null
    }
  },
  watch: {
    visible(val) {
      if (!val) {
        this.value = null
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('onClose')
    },
    handleSubmit() {
      if (this.value === null) {
        this.$message.error(this.$t('Message.PleaseSelectTheExportTemplate'))
        return
      }
      this.$emit('onSubmit', this.value)
    }
  }
}
</script>
<style lang="scss">
.template-selcte-dialog {
  .el-radio-group {
    display: flex;
    flex-direction: column;
    .el-radio {
      padding: 5px 0;
    }
  }
}
</style>
